import classNames from 'classnames';

import styles from './Field.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  isFullWidth?: boolean;
}

const Field: React.FC<Props> = ({
  className,
  children,
  isFullWidth = false,
}) => (
  <div
    className={classNames(styles.field, className, {
      [styles.max]: isFullWidth,
    })}
  >
    {children}
  </div>
);

export default Field;
